import React, { useEffect, useState } from 'react';
import FinancialInstitutionLayout from '../../../components/Layout/FinancialInstitution';
import { innerFooterItems } from '../../../components/Layout/FinancialInstitution/Footer';

function InnerApplication() {
  document.title = 'Financial Institution: Application';
  const [currPath, setCurrPath] = useState('/guidance');

  useEffect(() => {
    const iframePath = sessionStorage.getItem('iframe-path');

    /** When layout renders first for the first time - set key of iframe path to '', to trigger notices modal */
    if (iframePath === undefined || iframePath === null) {
      sessionStorage.setItem('iframe-path', '');
    }

    setCurrPath(iframePath || '/guidance');
  }, []);
  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      if (event.data?.type === 'LOGOUT') {
        sessionStorage.clear();
        localStorage.clear();
        window.location.href = '/guidance/single-sign-on';
      }
    };

    window.addEventListener('message', handleMessage);

    return () => window.removeEventListener('message', handleMessage);
  }, []);

  return (
    <FinancialInstitutionLayout footerItems={innerFooterItems}>
      <iframe
        title="application"
        src={currPath}
        width="100%"
        // height="600px"
        className="block h-[calc(100vh-64px-58px-48px)] md:h-[81vh]" // h-[100vh]
      />
    </FinancialInstitutionLayout>
  );
}

export default InnerApplication;
